export default "__VITE_ASSET__DS5MVz1R__"